import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';

import COLORS from '@styles/theme/colors';

interface IconWrap {
  bgcolor: string;
}

export const StyledDialog = styled(Dialog)({
  width: 'auto',
  minWidth: 390,
  '& h2': {
    fontSize: 18,
    padding: 0,
    flex: '1 1 auto'
  }
});

export const StyledDialogHead = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: 15,
  marginTop: 15
});

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: 8,
  right: 8,
  color: COLORS.textSecondColor,
  border: 'none',
  background: 'transparent'
});

export const IconWrap = styled('div')<IconWrap>(({ bgcolor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  marginRight: 15,
  width: 44,
  height: 44,
  borderRadius: 4,
  backgroundColor: bgcolor,
}));

export const StyledDialogActions = styled(DialogActions)({
  marginTop: 10,
  borderTop: '1px solid #EBEFF2',
  padding: 20,
  '& button:not(:first-of-type)': {
    marginLeft: 25
  },
  '& button': {
    padding: 10
  }
});
